import { render } from "./tpl_text_picture.vue?vue&type=template&id=2f17e877&scoped=true"
import script from "./tpl_text_picture.vue?vue&type=script&lang=js"
export * from "./tpl_text_picture.vue?vue&type=script&lang=js"

import "./tpl_text_picture.vue?vue&type=style&index=0&id=2f17e877&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f17e877"],['__file',"src/views/dragger/template/tpl_text_picture.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f17e877"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f17e877', __exports__)) {
    console.log('reload')
    api.reload('2f17e877', __exports__)
  }
  
  module.hot.accept("./tpl_text_picture.vue?vue&type=template&id=2f17e877&scoped=true", () => {
    console.log('re-render')
    api.rerender('2f17e877', render)
  })

}


export default __exports__